/**
 * Petal Quiz Configuration
 * Define all quiz questions and settings
 */

window.quizConfigs = {
  // Petal Skincare Quiz
  petal: {
    id: 'petal-quiz',
    logoUrl: '//cdn.shopify.com/s/files/1/0719/1881/3437/files/Petal_Logo_no_background.png?v=1726365622',
    logoAlt: 'Petal',
    webhookUrl: 'https://hooks.zapier.com/hooks/catch/2394871/u9jzuxc/',
    successRedirect: '/',
    welcomeCode: 'WELCOME15',
    
    questions: [
      {
        id: 'skin-concern',
        type: 'radio',
        title: 'What is your biggest skin concern right now?',
        required: true,
        layout: 'vertical',
        autoAdvance: true,
        options: [
          { value: 'fine-lines', label: 'Fine lines or early wrinkles' },
          { value: 'dull-skin', label: 'Dull or tired-looking skin' },
          { value: 'uneven-texture', label: 'Uneven texture or enlarged pores' },
          { value: 'firmer-younger', label: 'I just want my skin to look firmer and younger' }
        ],
        errorMessage: 'Please select your skin concern'
      },
      {
        id: 'treatment-frequency',
        type: 'radio',
        title: 'How often do you currently do treatments at home (like masks, serums, or devices)?',
        required: true,
        layout: 'vertical',
        autoAdvance: true,
        options: [
          { value: 'rarely', label: 'Rarely - I keep it simple' },
          { value: 'few-times-month', label: 'A few times a month' },
          { value: 'weekly', label: 'Weekly - I love skincare routines' }
        ],
        errorMessage: 'Please select treatment frequency'
      },
      {
        id: 'skin-sensitivity',
        type: 'radio',
        title: 'How would you describe your skin sensitivity?',
        required: true,
        layout: 'vertical',
        autoAdvance: false,
        options: [
          { value: 'very-sensitive', label: 'Very sensitive - I am cautious with new products' },
          { value: 'normal', label: 'Normal - I can handle most treatments' },
          { value: 'resilient', label: 'Resilient - I am comfortable with active ingredients' }
        ],
        errorMessage: 'Please select your skin sensitivity',
        onShow: function(quiz) {
          const question = quiz.config.questions[quiz.currentQuestionIndex];
          const questionEl = quiz.form.querySelector('[data-question-id="' + question.id + '"]');
          
          // Add event listener for "Very sensitive" option
          const verySensitiveOption = questionEl.querySelector('input[value="very-sensitive"]');
          if (verySensitiveOption && !verySensitiveOption.hasListener) {
            verySensitiveOption.hasListener = true;
            verySensitiveOption.addEventListener('change', function() {
              if (this.checked) {
                const modal = document.createElement('div');
                modal.className = 'quiz-overlay';
                modal.innerHTML = '<div class="quiz-modal"><h2>A Quick Note About Sensitive Skin</h2><p>Microneedling can be effective for sensitive skin, but we recommend starting with extra caution. Consider consulting your dermatologist first, and always perform a patch test. Ready to continue?</p><button class="quiz-modal-btn quiz-modal-confirm">Continue to Next Question</button></div>';
                document.body.appendChild(modal);
                
                modal.querySelector('.quiz-modal-confirm').addEventListener('click', function() {
                  modal.remove();
                  quiz.nextQuestion();
                });
              }
            });
          }
          
          // Auto-advance for "Normal" option
          const normalOption = questionEl.querySelector('input[value="normal"]');
          if (normalOption && !normalOption.hasListener) {
            normalOption.hasListener = true;
            normalOption.addEventListener('change', function() {
              if (this.checked) {
                setTimeout(function() { quiz.nextQuestion(); }, 300);
              }
            });
          }
          
          // Auto-advance for "Resilient" option
          const resilientOption = questionEl.querySelector('input[value="resilient"]');
          if (resilientOption && !resilientOption.hasListener) {
            resilientOption.hasListener = true;
            resilientOption.addEventListener('change', function() {
              if (this.checked) {
                setTimeout(function() { quiz.nextQuestion(); }, 300);
              }
            });
          }
        }
      },
      {
        id: 'contact-info',
        type: 'form',
        title: 'Great news! Microneedling can help.',
        description: 'Microneedling can smooth fine lines, boost collagen, and improve radiance. Enter your email below and we will send you an exclusive discount code to get started.',
        required: true,
        errorContainer: true,
        submitButton: true,
        submitText: 'Get My Discount Code',
        fields: [
          {
            id: 'first-name',
            name: 'firstName',
            type: 'text',
            placeholder: 'First Name',
            required: true,
            pattern: '^[a-zA-Z\\s]+$',
            errorMessage: 'First Name is required',
            validationMessage: 'Please enter a valid name (letters only)'
          },
          {
            id: 'email',
            name: 'email',
            type: 'email',
            placeholder: 'Email',
            required: true,
            errorMessage: 'Email is required'
          }
        ],
        disclaimer: '<p style="text-align: center;color:#888;font-size: 12px;margin-top: 3%;">By submitting this form, you agree to receive promotional emails from Petal. You can unsubscribe at any time. View <a href="/pages/terms-of-service" style="color:#888;text-decoration:underline;">Terms</a> & <a href="/pages/privacy-policy" style="color:#888;text-decoration:underline;">Privacy</a>.</p>'
      }
    ],
    
    successMessage: {
      title: 'Check your email!',
      content: 'We have sent your exclusive discount code to your inbox. Use code WELCOMECODE for your special offer.',
      buttonText: 'Shop Now',
      buttonUrl: '/collections/all'
    },
    
    additionalData: {
      source: function() { 
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('utm_source') || document.referrer || 'direct';
      }
    }
  }
};